<template lang="pug">
div
  h1 Carregando
</template>
<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue2-helpers/vue-router';

const router = useRouter()

onMounted(() => {
  window.addEventListener("message", function (event) {
    try {
      const eventData = JSON.parse(event.data);

      console.log('Message from Chatwoot', eventData);

      router.push({ name: 'customer-detail', params: { 'id': 1 }})
    } catch (e) {
      console.error(e);
    }
  })

  window.parent.postMessage('chatwoot-dashboard-app:fetch-info', '*')
})
</script>
